import { render, staticRenderFns } from "./Sensors.vue?vue&type=template&id=6405197c&scoped=true&"
import script from "./Sensors.vue?vue&type=script&lang=js&"
export * from "./Sensors.vue?vue&type=script&lang=js&"
import style0 from "./Sensors.vue?vue&type=style&index=0&id=6405197c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6405197c",
  null
  
)

export default component.exports